import { inject, Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable()
export class AdvTradingTrackingService {
	private readonly segmentService = inject(SegmentService);
	private readonly rudderstackService = inject(RudderstackService);

	public trackCloseModal(exitSource: string): void {
		this.segmentService.track({
			name: "Advanced Trading Modal Closed",
			properties: { exit_source: exitSource }
		});
		this.rudderstackService.track({
			name: "Advanced Trading Modal Closed",
			properties: { exit_source: exitSource }
		});
	}

	public depositButtonClicked(): void {
		this.segmentService.track({
			name: "Deposit CTA clicked",
			properties: { screen_it_happened_on: "advanced_trading_modal" }
		});
		this.rudderstackService.track({
			name: "Deposit CTA clicked",
			properties: { screen_it_happened_on: "advanced_trading_modal" }
		});
	}

	public flowStarted(): void {
		this.segmentService.track({ name: "Advanced Trading Flow Started" });
		this.rudderstackService.track({ name: "Advanced Trading Flow Started" });
	}

	public flowCompleted(): void {
		this.segmentService.track({
			name: "Advanced Trading Flow Completed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "Advanced Trading Flow Completed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}

	public bannerWasClicked(touchpoint: string): void {
		this.segmentService.track({
			name: "Advanced Trading Banner CTA Clicked",
			properties: {
				touchpoint: touchpoint
			}
		});
		this.rudderstackService.track({
			name: "Advanced Trading Banner CTA Clicked",
			properties: {
				touchpoint: touchpoint
			}
		});
	}

	public toggleWasClicked(): void {
		this.segmentService.track({ name: "Advanced Trading Modal Toggle Clicked" });
		this.rudderstackService.track({ name: "Advanced Trading Modal Toggle Clicked" });
	}

	public confirmAddressWasClicked(): void {
		this.segmentService.track({
			name: "Confirm Address Button Clicked ",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "Confirm Address Button Clicked ",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}

	public selfCertInfoCardDisplayed(): void {
		this.segmentService.track({
			name: "Self-cert Info Card Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "Self-cert Info Card Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}

	public cryptoDeclarationWarningDisplayed(undeclaredDeposits: boolean): void {
		this.segmentService.track({
			name: "Crypto Declaration Warning Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal", undeclared_deposits: undeclaredDeposits }
		});
		this.rudderstackService.track({
			name: "Crypto Declaration Warning Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal", undeclared_deposits: undeclaredDeposits }
		});
	}

	public noFundsErrorDisplayed(): void {
		this.segmentService.track({
			name: "No Funds Info Card Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "No Funds Info Card Displayed",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}

	public learnMoreButtonClicked(): void {
		this.segmentService.track({
			name: "Learn More Button Clicked",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "Learn More Button Clicked",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}

	public shareDetailsButtonClicked(): void {
		this.segmentService.track({
			name: "Share Details Button Clicked",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
		this.rudderstackService.track({
			name: "Share Details Button Clicked",
			properties: { screen_it_happened_on: "Fusion onboarding modal" }
		});
	}
}
